<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for">Foreword by Cyril O’Regan</a></p>
<p class="Toc1" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc1" id="int"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="Toc-pt" id="pt-001"><span href="#/xhtml/part001#pt001" title="Link target outside of Sample">Part 1. Formal and Critical Dialogue</span></p>
<p class="Toc" id="ch-001"><span href="#/xhtml/chapter001#ch001" title="Link target outside of Sample">1.<span class="space1">A Crossroad Moment for Catholic Thought: The Modernist Crisis</span></span></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space1"><i>Philo</i>sophy and <i>Theo</i>logy: Modernity and Countermodernity</span></span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">Visions of Being: Foundation and Nonfoundation</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Differing Reimaginings of the <i>Analogia Entis</i>: Anthropocentrism and Theocentrism</span></span></p>
<p class="Toc-pt" id="pt-002"><span href="#/xhtml/part002#pt002" title="Link target outside of Sample">Part 2. Constructive Reimagining</span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Setting the Stage: Post-Conciliar Trajectories</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">The Postmodern Scene of Thought: Breaking Heidegger’s Spell</span></span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">The Resurgence of Analogical Metaphysics: Desmond, Milbank, and Hart</span></span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">Enlisting Apocalyptic <i>Theo</i>logy: Cyril O’Regan’s Pleromatic Vision</span></span></p>
<p class="Toc" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.<span class="space1">The <i>Analogia Entis</i> Reimagined: A Christian Analogical-Apocalyptic Metaphysics</span></span></p>
<p class="Toc1a" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc1" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?66bb4f46